import React from 'react';
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import List from '@mui/material/List';
import ListItem from "@mui/material/ListItem"
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import RadioButtonUnncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import TableCell from '@mui/material/TableCell';
import Link from "@mui/material/Link";

const useStyles = {
    text: {
        color: 'text.primary',
        fontSize: '1rem'
    },
    bold: {
        fontWeight: "bold",
    },
    italic: {
        fontStyle: 'italic',
    },
    boldItalic: {
        fontStyle: 'italic',
        fontWeight: 'bold',
    },
    table: {
        borderColor: 'text.primary',
        borderStyle: 'solid',
        borderWidth: '2px',
        padding: '5px',
        verticalAlign: 'top',
    }
}

const Privacy = () => {

    const classes = useStyles;

    return (
        <Grid container spacing={1} sx={classes.text}>
            <Grid style={{textAlign: 'center'}} size={12}>
                <Typography variant='h6' sx={classes.bold}>
                    Payment Portal Privacy Policy
                </Typography>
            </Grid>
            <Grid size={12}>
                This Privacy Policy ("Policy") governs Your use of the NEUMO Payments portal where you may access various
                services, including the ability to view amounts due under Your Account account, make payments through the
                portal, establish payment arrangements, and maintain and update contact information and preferences
                (<Typography component='span' sx={classes.italic}>"Payment Portal"</Typography>).  By using the Payment Portal you agree to the terms of this Policy.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.italic}>"Subscriber"</Typography> means a government agency,
                court, or municipality that has subscribed to use the Payment Portal enabling it to collect payments through
                the Payment Portal and to host and update Your account information.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.italic}>"You"</Typography> are an individual that has
                been invited to use the Payment Portal by a Subscriber to make a payment and access, maintain and update the
                account information the Subscriber has on file for You.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.italic}>"Justice Systems"</Typography> means Justice Systems, Inc.
                and its affiliates. Justice Systems has licensed the Payment Portal to the Subscriber to use.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.bold}>
                    Information Collected
                </Typography>
            </Grid>
            <Grid size={12}>
                Your use of the Payment Portal involves You submitting and verifying information provided by the Subscriber for the
                purposes of keeping updated account information for Your account and making a payment online. The types of
                information that may be collected are:
            </Grid>
            <Grid size={12}>
                <Table width='100%' sx={classes.table}>
                    <TableBody>
                        <TableRow>
                            <TableCell align='left' width='25%' sx={classes.table}>Unique Identifiers</TableCell>
                            <TableCell align='left' width='75%' sx={classes.table}>First and last name, social security number
                                (or a portion thereof), mailing address, billing address, telephone number, email address, account
                                name, IP address, geolocation, tax identification number, or other similar identifiers
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align='left' width='25%' sx={classes.table}>Personal Information</TableCell>
                            <TableCell align='left' width='75%' sx={classes.table}>
                                First and last name, social security number (or a portion thereof), address, telephone number,
                                email address, credit card or debit card information, bank information, ACH information, tax
                                identification number, or other similar information related to making payments or contacting You
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align='left' width='25%' sx={classes.table}>Age Information</TableCell>
                            <TableCell align='left' width='75%' sx={classes.table}>
                                Birthdate
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align='left' width='25%' sx={classes.table}>Commercial Information</TableCell>
                            <TableCell align='left' width='75%' sx={classes.table}>
                                Payment history
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align='left' width='25%' sx={classes.table}>Geolocation Data</TableCell>
                            <TableCell align='left' width='75%' sx={classes.table}>
                                IP address and geolocation
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align='left' width='25%' sx={classes.table}>Other Information</TableCell>
                            <TableCell align='left' width='75%' sx={classes.table}>
                                Contact preferences and consents, username and password for use of the Payment Portal,
                                original creditor information, and other similar information.
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Grid>
            <Grid size={12}>
                The information collected either comes from You or the Subscriber. Justice Systems has no control of
                the information collected by the Subscriber outside of the Payment Portal nor does Justice Systems
                validate the information You provide.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.bold}>
                    Use of Information
                </Typography>
            </Grid>
            <Grid size={12}>
                Justice Systems will use and save Your information to satisfy the reason You provided the information.
                Justice Systems may also use Your information:
            </Grid>
            <List width='100%' spacing={1}>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon display='inline-flex' style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        To support the Subscriber in its use of the Payment Portal.
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon style={{fontSize: '.8rem'}}/></ListItemIcon>
                    <ListItemText>
                        To help maintain the safety, security and integrity of the Payment Portal.
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon style={{fontSize: '.8rem'}}/></ListItemIcon>
                    <ListItemText>
                        To respond to law enforcement requests, respond to a regulatory audit requests,
                        and to disclose information as otherwise required by applicable law, court order,
                        subpoena, or governmental regulations.
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon style={{fontSize: '.8rem'}}/></ListItemIcon>
                    <ListItemText>
                        As described to You when collecting Your information or as otherwise permitted
                        in applicable law or regulation.
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon style={{fontSize: '.8rem'}}/></ListItemIcon>
                    <ListItemText>
                        To valuate or conduct a merger, divestiture, restructuring, reorganization,
                        dissolution, or other sale or transfer of some or all of Justice Systems’ assets,
                        whether as a going concern or as part of bankruptcy, liquidation, or similar
                        proceeding, in which personal information held in the Payment Portal is among the
                        assets transferred.
                    </ListItemText>
                </ListItem>
            </List>
            <Grid size={12}>
                <Typography component='span' sx={classes.bold}>
                    Use of Cookies
                </Typography>
            </Grid>
            <Grid size={12}>
                Justice Systems currently does not use cookies with the Payment Portal but reserves the
                right to do so in the future for the purposes of processing payments, understanding Your
                preferences based on previous or current site activity, and to compile aggregate data
                about site traffic. All this information would be used to assist Justice Systems in providing
                improved services and providing better site and user experiences.
            </Grid>
            <Grid size={12}>
                Cookies are small files that a site or its service provider transfers to Your computer's
                hard drive through Your Web browser (if You allow) that enables the site's or service
                provider's systems to recognize Your browser and capture and remember certain information.
                Through Your browser (i.e., Internet Explorer), You can choose to have Your computer warn
                You each time a cookie is being sent, or You can choose to disable third party cookies and
                enable first party cookies. You can learn how to enable these setting by accessing Your
                browser's help menu.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.bold}>
                    Sharing of Information
                </Typography>
            </Grid>
            <Grid size={12}>Justice Systems does not sell Your information and only discloses
                information in compliance with applicable laws and regulations. Justice Systems may
                share Your information with:
            </Grid>
            <List width='100%' spacing={1}>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon display='inline-flex' style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        Payment processors, card networks, financial institutions, and other service providers to process payments;
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon display='inline-flex' style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        The Subscriber that requested that You use the Payment Portal;
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon display='inline-flex' style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        Hosting service providers in order to provide the Payment Portal;
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon display='inline-flex' style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        Service providers and third-party tools used to help keep the environment secure and prevent fraud and abuse
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon display='inline-flex' style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        Third parties, as needed, to prevent any physical harm or illegal activity or to respond to a court order,
                        governmental inquiry, regulatory action, subpoena, or to otherwise comply with laws and regulations;
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon display='inline-flex' style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        Third parties to verify compliance with acceptable use policies, contractual terms or card association
                        rules; and
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon display='inline-flex' style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        Advisors and third parties to facilitate a merger, purchase, divesture, reorganization, dissolution or
                        other sale or transfer of some or all of Justice Systems’ assets, whether as a going concern or as part
                        of bankruptcy, liquidation, or similar proceeding, in which personal information held in the Payment
                        Portal is among the assets transferred.
                    </ListItemText>
                </ListItem>
            </List>
            <Grid size={12}>
                Please note that Justice Systems does not have control over the information sharing practices of the Subscriber
                or with which third parties Subscriber shares information. Please consult the Subscriber’s privacy policy for
                information related to its information sharing practices.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.bold}>
                    Protection of Information
                </Typography>
            </Grid>
            <Grid size={12}>
                Justice Systems maintains PCI-DSS compliance for the Payment Portal and undergoes annual audits to certify
                that compliance.  Justice Systems stores information in secured networks that are only accessible by a limited
                number of authorized personnel that need access to allow Justice Systems to provide the Payment Portal. Justice
                Systems utilizes a variety of technical, physical, and administrative security measures (e.g., firewalls,
                encryption, and network access controls) to maintain the security of the information contained within the Payment
                Portal. While Justice Systems protects the Payment Portal, You are responsible for keeping Your username, password,
                and account information private. You are also responsible for making sure Your personal information is accurate
                and up to date.
            </Grid>
            <Grid size={12}>
                If Your account is closed, Justice Systems may keep Your information as required by law and according to its
                data retention policy. If Justice Systems does, Justice Systems will continue to handle the information as
                described in this Policy.
            </Grid>
            <Grid size={12}>
                Please note that Justice Systems does not have control over the security practices of the Subscriber. Please
                consult the Subscriber’s privacy policy for information related to its security practices.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.bold}>
                    Minors
                </Typography>
            </Grid>
            <Grid size={12}>
                The Payment Portal is not intended for children. If You are below the age of 13, You must not use the Payment
                Portal or submit any personal information to the Payment Portal. Justice Systems does not knowingly accept
                any registrations or other personal information from those under the age of 13.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.bold}>
                    California Residents – Disclosures, Rights and Privacy Requests
                </Typography>
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.italic}>
                    Disclosures
                </Typography>
            </Grid>
            <Grid size={12}>
                The California Consumer Privacy Act (“CCPA”) requires specific disclosures
                for California residents. To accomplish those, this Privacy Policy helps
                You understand how Justice Systems handles Your information by explaining:
            </Grid>
            <List width='100%' spacing={1}>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        The information Justice Systems collects and the sources of that
                        information (See the section of this Privacy Policy entitled
                        <Typography component='span' sx={classes.italic}>"Information Collected"</Typography> above).
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        How Justice Systems uses that information (See the section of this Privacy Policy entitled <Typography
                        component='span' sx={classes.italic}>"Use of Information"</Typography> above).
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        Who and why Justice Systems may share that information (See the section of this Privacy Policy entitled
                        <Typography component='span' sx={classes.italic}>"Sharing of Information"</Typography> above).
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemIcon><RadioButtonUnncheckedIcon style={{fontSize: '.8rem',}}/></ListItemIcon>
                    <ListItemText>
                        Justice Systems does not sell Your information.
                    </ListItemText>
                </ListItem>
            </List>
            <Grid size={12}>
                <Typography component='span' sx={classes.italic}>CCPA Rights</Typography>
            </Grid>
            <Grid size={12}>
                The CCPA also permits consumers who are California residents to: (a) request information about how
                Justice Systems collects, uses and discloses their information over the past 12 months; (b) opt out
                of Justice Systems selling their information; (c) request Justice Systems delete their information;
                and (d) request certain information regarding Justice Systems's disclosure of personal information
                to third parties for their direct marketing purposes under California’s "Shine the Light Law" (Civil
                Code Section 1798.83). The CCPA also provides the right to not be discriminated against by a California
                resident for exercising any of the privacy rights. Justice Systems will not discriminate against You
                for exercising any of these rights. You should note that these rights do not apply to certain exempted
                activities provided under the CCPA (e.g., personal data collected, processed, shared, or disclosed by
                financial institutions pursuant to federal law such as the Gramm-Leach-Bliley Act).
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.italic}>Making a CCPA Privacy Request</Typography>
            </Grid>
            <Grid size={12}>
                If You are a California resident, You may exercise Your rights under the CCPA by submitting a request
                to the Subscriber by following the Subscriber’s procedures outlined in the Subscriber’s privacy policy.
                You may also submit a request to Justice Systems through the following email:
                <Link href="mailto:citepaysupport@avenuinsights.com">citepaysupport@avenuinsights.com</Link>. You may also contact Justice Systems
                as set forth in the section of this Privacy Policy entitled "Contact Justice Systems" below.
            </Grid>
            <Grid size={12}>
                When submitting a request to Justice Systems, please identify the Justice Systems Omni Payment Portal
                when making such a request, the Subscriber, and describe Your request with sufficient detail to allow
                Justice Systems to properly understand, evaluate and respond to it. There is no fee for making a request.
                The CCPA provides for how long Justice Systems has to respond and governs the number of times You may
                submit a request over the course of a year.
            </Grid>
            <Grid size={12}>
                Upon submitting a request to Justice Systems under the CCPA, Justice Systems will seek to validate Your
                identity in accordance with the CCPA. To do so, Justice Systems may request additional information and
                You will be responsible for providing that information. If You fail to do so, You understand that Justice
                Systems will not be able to respond to Your request. To the extent Justice Systems does not already have
                the information You provide to validate Your identity, Justice Systems will only use that information for
                that purpose.
            </Grid>
            <Grid size={12}>
                The CCPA provides for a variety of exceptions to Your rights under the CCPA and as result, Justice Systems
                may have reasons to deny a specific request. If that were to occur, Justice Systems will inform You of the
                denial and the basis for such denial.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.italic}>Opt-Out of Sale of Personal Information</Typography>
            </Grid>
            <Grid size={12}>
                If you are 16 years of age or older, You have the right to direct Justice Systems to not sell Your personal
                information at any time (the "right to opt-out"). Justice Systems does not currently sell the personal
                information of users of the Payment Portal nor will Justice Systems ever sell personal information of any
                user it knows are less than 16 years of age, unless Justice Systems receives affirmative authorization (the
                "right to opt-in") from either the consumer who is at least 13 but not yet 16 years of age, or the parent or
                guardian of a consumer less than 13 years of age. Consumers who opt-in to personal information sales may
                opt-out of future sales at any time. To exercise the right to opt-out, You (or Your authorized representative)
                may submit a request to Justice Systems by sending an email to:
                <Link href="mailto:citepaysupport@avenuinsights.com">citepaysupport@avenuinsights.com</Link>.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.bold}>INDIVIDUALS IN THE EUROPEAN ECONOMIC AREA</Typography>
            </Grid>
            <Grid size={12}>
                The Payment Portal is not intended for use and does not target end users located in the European Economic
                Area. Any requests related to the European Union (EU) General Data Protection Regulation (GDPR) should be
                directed to the Subscriber that requested that You use the Payment Portal.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.bold}>CHANGES TO THIS PRIVACY POLICY</Typography>
            </Grid>
            <Grid size={12}>
                Justice Systems reserves the right to amend this Privacy Policy at Justice Systems’ discretion and at any
                time. When Justice Systems makes changes to this privacy notice, Justice Systems will post the updated notice
                on the Payment Portal and update the notice's effective date. Your continued use of the Payment Portal
                following the posting of changes constitutes Your acceptance of such changes.
            </Grid>
            <Grid size={12}>
                <Typography component='span' sx={classes.bold}>CONTACT JUSTICE SYSTEMS</Typography>
            </Grid>
            <Grid size={12}>
                If you have any questions regarding this Privacy Statement, You may contact Justice Systems by using the information below.
            </Grid>
            <Grid size={12}>
                Justice Systems, Inc.<br/>
                860 Trinity Parkway, Suite 120.<br/>
                Centreville, VA 20120<br/>
                Attn: Legal Department<br/>
                Tel +1-800-927-5125<br/>
                <Link href="mailto:citepaysupport@avenuinsights.com">citepaysupport@avenuinsights.com</Link>
            </Grid>
            <Grid style={{marginTop: '15px'}} size={12}>
                © 2008-{`${new Date().getFullYear()}`} Justice Systems Inc. all rights reserved.
            </Grid>
        </Grid>
    );
};

export default Privacy;